import { Navigate, RouteObject } from 'react-router-dom';

import ProfilePage from '@/pages/ProfilePage';
import ProfilePageGeneralInfo from '@/pages/ProfilePage/ProfilePageGeneralInfo';

import { RoutePath } from '../RoutePath';

import { getCrmAuthorizationsRoutes } from './getCrmAuthorizationsRoutes';
import { getCRMBedboardRoutes } from './getCrmBedboardRoutes';
import { getCrmMedicaidPendingRoutes } from './getCrmMedicaidPendingRoutes';
import { getCrmReferralOutboundRoutes } from './getCrmReferralOutboundRoutes';
import { getCrmScreenerResidentsRoutes } from './getCrmScreenerResidentsRoutes';
import { getCrmScreenerRoutes } from './getCrmScreenerRoutes';
import { getCrmSourcesRoutes } from './getCrmSourcesRoutes';
import { getCrmTasksRoutes } from './getCrmTasksRoutes';
import { getCrmWaitlistRoutes } from './getCrmWaitlistRoutes';

export const getCrmRoutes = (): RouteObject[] => {
  return [
    {
      path: RoutePath.Profile,
      element: <ProfilePage />,
      children: [
        {
          index: true,
          element: <ProfilePageGeneralInfo />
        }
      ]
    },
    ...getCrmTasksRoutes(),
    ...getCrmScreenerRoutes(),
    ...getCrmAuthorizationsRoutes(),
    ...getCrmScreenerResidentsRoutes(),
    ...getCrmSourcesRoutes(),
    ...getCrmWaitlistRoutes(),
    ...getCRMBedboardRoutes(),
    ...getCrmReferralOutboundRoutes(),
    ...getCrmMedicaidPendingRoutes(),
    // Catch-all route
    {
      path: '/*',
      element: <Navigate to={RoutePath.CRMScreenerAllLeads} replace />
    }
  ];
};
